/*
 * FP: running total on the fabric PDP's add-to-cart button — "ADD TO CART · ₹ 1,978".
 *
 * Clarity (Diwali Day 1): shoppers who tapped + but never added kept moving the
 * quantity up and down and switching between By meter and pre-cut pieces. The
 * confirmation line already says what they will receive; the button now says
 * what they will pay.
 *
 * Loaded for per-mtr fabrics and shirt + trouser sets ("ADD SET TO CART ·
 * ₹ 2,999"), from blocks/buy-buttons.liquid. Display only:
 * never touches the button's state, events or the form. Re-applied after every
 * variant morph, which re-renders the button without the total.
 */
(function () {
  'use strict';

  if (window.fpAtcTotalInit) return;
  window.fpAtcTotalInit = true;

  function paint() {
    var root = document.querySelector('.product-information') || document;
    var qty = root.querySelector('quantity-selector-component');
    var form = qty && qty.closest('form');
    var btn = form && form.querySelector('add-to-cart-component button[name="add"]');
    var holder = btn && btn.querySelector('.add-to-cart-text__content > span');
    if (!holder) return;

    var text = '';
    if (!btn.disabled) {
      // Same guards as fp-optimistic-add.js: one .money (volume pricing renders a
      // range), whole rupees, and below ₹1,00,000 (en-IN grouping matches
      // Shopify's only below a lakh). Anything else shows no total.
      var priceRoot = root.querySelector('.price');
      var monies = priceRoot ? priceRoot.querySelectorAll('.money') : [];
      if (monies.length === 1) {
        var unit = monies[0].textContent.replace(/\s+/g, ' ').trim();
        var unitInt = parseInt(unit.replace(/[^\d]/g, ''), 10);
        var input = qty.querySelector('input[type="number"]');
        var n = input ? parseInt(input.value, 10) : 1;
        if (!isFinite(n) || n < 1) n = 1;
        if (!/\.\d/.test(unit) && unitInt > 0 && unitInt * n < 100000) {
          text = ' · ' + unit.replace(/[\d,]+/, (unitInt * n).toLocaleString('en-IN'));
        }
      }
    }

    var tag = holder.querySelector('.fp-atc-total');
    if (!text) {
      if (tag) tag.remove();
      return;
    }
    if (!tag) {
      tag = document.createElement('span');
      tag.className = 'fp-atc-total';
      holder.appendChild(tag);
    }
    if (tag.textContent !== text) tag.textContent = text;
  }

  function run() {
    try {
      paint();
    } catch (e) {}
  }

  // Quantity buttons and variant pickers update the DOM after their own
  // handlers run, so read on the next frame. The timeout covers browsers that
  // hold back frames (background tabs, some in-app WebViews); painting twice
  // is harmless.
  function later() {
    requestAnimationFrame(run);
    setTimeout(run, 150);
  }

  function fromQty(e) {
    if (e.target && e.target.closest && e.target.closest('quantity-selector-component')) later();
  }

  document.addEventListener('variant:selected', later);
  document.addEventListener('variant:update', later);
  document.addEventListener('click', fromQty);
  document.addEventListener('input', fromQty);
  document.addEventListener('change', fromQty);
  later();
})();
